import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from './cookie.service';
import { AnalyticsService } from './analytics.service';
import { MetaService } from './meta.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AnalyticsService, CookieService, MetaService],
})
export class CoreModule {}
